// 基础
import Cookies from 'js-cookie'
import config from '@/config'
export const TOKEN_KEY = 'mentee-token'
export const USER_AVATOR = 'mentee-avatar'
export const COACH_EVALUATE = 'mentee-coach-evaluate'
export const ESSAY_EVALUATE = 'mentee-essay-evaluate'
export const CVRL_EVALUATE = 'mentee-cvrl-evaluate'
// 设置token
export const setToken = token => {
  Cookies.set(TOKEN_KEY, token, { expires: config.cookieExpires || 1 })
}
// 删除token
export const removetToken = () => {
  Cookies.remove(TOKEN_KEY)
}
// 获取token
export const getToken = () => {
  const token = Cookies.get(TOKEN_KEY)
  if (token) return token
  else return false
}
// 设置头像
export const setUserAvatar = data => {
  Cookies.set(USER_AVATOR, data, { expires: config.cookieExpires || 1 })
}
// 获取用户头像
export const getUserAvatar = () => {
  const userAvatar = Cookies.get(USER_AVATOR)
  const data =
    userAvatar !== 'undefined' && userAvatar !== 'null' ? userAvatar : ''
  return data
}
// 设置是否评价
export const setEvaluate = (key, beal) => {
  Cookies.set(key, beal, { expires: 1 / 96 })
}
// 获取评价
export const getEvaluate = key => {
  return Cookies.get(key)
}
